import type { ILoggerConfiguration } from '@dicetechnology/dice-unity/lib/services/Logger/types';

import pkg from '../../package.json';

import { API_KEY } from './API_KEY';

export const LOGGER_OPTIONS: Omit<ILoggerConfiguration, 'realm'> = {
    apiKey: API_KEY,
    appName: 'chromecast',
    environment: process.env.NODE_ENV,
    version: pkg.version
};
